export default class StandardsClient {
    constructor(apiClient) {
        this.apiClient = apiClient;
        this.getCountries = this.getCountries.bind(this);
        this.getCurrencies = this.getCurrencies.bind(this);
        this.getCountryCodes = this.getCountryCodes.bind(this);
        this.getTimeZones = this.getTimeZones.bind(this);
        this.postSpecialization = this.postSpecialization.bind(this);
        this.deleteSpecialization = this.deleteSpecialization.bind(this);
        this.getSpecializations = this.getSpecializations.bind(this);
    }
    getCountries(config) {
        return this.apiClient.get('/v3/countries', config);
    }
    getCurrencies(config) {
        return this.apiClient.get('/v3/currencies', config);
    }
    getCountryCodes(config) {
        return this.apiClient.get('/v3/country_codes', config);
    }
    getTimeZones(config) {
        return this.apiClient.get('/v3/time_zones', config);
    }
    postSpecialization(data, config) {
        return this.apiClient.post('/v3/specializations', data, config);
    }
    deleteSpecialization(name, config) {
        return this.apiClient.delete(`/v3/specializations/${name}`, config);
    }
    getSpecializations(config) {
        return this.apiClient.get('/v3/specializations', config);
    }
}
